import "./FlyFishingWebsiteLodgingOptions.module.css";
import Header from "@/reusable_sections/Header";
import LodgingOverview from "./sections/LodgingOverview";
import CabinDetails from "./sections/CabinDetails";
import BookingIntegration from "./sections/BookingIntegration";
import Footer from "@/reusable_sections/Footer";
export default function FlyFishingWebsiteLodgingOptionsPage() {
  return <div>
      <Header />
      <LodgingOverview />
      <CabinDetails />
      <BookingIntegration />
      <Footer />
    </div>;
}